import { Desktop } from 'styles/MediaQueries';
import BankrateLogo from 'images/cobranding/Bankrate.svg';
import ConsumerAffairLogo from 'images/cobranding/ConsumerAffair.svg';
import CredibleLogo from 'images/cobranding/CredibleLogo.svg';
import CreditKarmaLogo from 'images/cobranding/CreditKarma.svg';
import ExperianLogo from 'images/cobranding/Experian.svg';
import FixMediaLogo from 'images/cobranding/FixMedia.svg';
import LendingTreeLogo from 'images/cobranding/LendingTree.svg';
import MoneyLionLogo from 'images/cobranding/MoneyLion.svg';
import NerdWalletLogo from 'images/cobranding/NerdWallet.svg';
import React from 'react';
import WalletHubLogo from 'images/cobranding/WalletHub.svg';

const IMAGES_BY_PARTNER_ID = {
  212: CreditKarmaLogo,
  258: FixMediaLogo,
  268: LendingTreeLogo,
  303: NerdWalletLogo,
  345: BankrateLogo,
  398: ExperianLogo,
  414: WalletHubLogo,
  492: ConsumerAffairLogo,
  495: CredibleLogo,
  503: MoneyLionLogo
};

const STYLE_BY_PARTNER_ID = {
  212: {
    height: '2rem',

    [Desktop]: {
      height: '2.75rem'
    }
  },
  258: {
    height: '3.5rem',

    [Desktop]: {
      height: '4.5rem'
    }
  },
  268: {
    height: '3.5rem',
    marginTop: '-0.5rem',

    [Desktop]: {
      height: '4.5rem',
      marginTop: '-0.75rem'
    }
  },
  303: {
    height: '1.375rem',

    [Desktop]: {
      height: '2.875rem'
    }
  },
  345: {
    height: '1.5rem',

    [Desktop]: {
      height: '1.75rem'
    }
  },
  398: {
    height: '2.5rem',

    [Desktop]: {
      height: '3.25rem'
    }
  },
  414: {
    height: '1.75rem',

    [Desktop]: {
      height: '3rem'
    }
  },
  492: {
    height: '1.375rem',

    [Desktop]: {
      height: '2.25rem'
    }
  },
  495: {
    height: '1.5rem',

    [Desktop]: {
      height: '2.25rem'
    }
  },
  503: {
    height: '3.5rem',

    [Desktop]: {
      height: '5rem'
    }
  }
};

function PartnerLogo({ partnerId, partnerName, style = {} }) {
  const Logo = IMAGES_BY_PARTNER_ID[partnerId];
  const baseStyle = STYLE_BY_PARTNER_ID[partnerId] || {};

  if (!Logo) {
    return null;
  }

  return (
    <Logo
      css={[baseStyle, style]}
      data-testid='partner-logo'
      role='img'
      title={`${partnerName} Logo`}
    />
  );
}

export default PartnerLogo;
